import React from 'react';

import { useGamesSelector } from 'js/app/components/main/Games/store/context';

import { BingoTile, DetailedTile, ListTile } from './components';

export const GameTile = ({
    index,
    categoryName,
    gameData = {},
    viewModeInline,
    gameCodes = [],
    classNames = {},
    isShowJackpots,
    isBingo = false,
    isShowFavourites,
    isShowInfo,
    withBands,
    inlineGrid = null,
    isShowSashes,
    feedName
}) => {
    const { viewModeDetailed } = useGamesSelector();

    const Tile = isBingo ? BingoTile : viewModeDetailed ? DetailedTile : ListTile;

    return (
        <Tile
            index={index}
            categoryName={categoryName}
            gameCodes={gameCodes}
            gameData={gameData}
            viewModeInline={viewModeInline}
            classNames={classNames}
            isShowJackpots={isShowJackpots}
            isShowFavourites={isShowFavourites}
            isShowInfo={isShowInfo}
            withBands={withBands}
            inlineGrid={inlineGrid}
            isShowSashes={isShowSashes}
            feedName={feedName}
        />
    );
};
